import {useCallback} from 'react';
import {useAuthenticator} from '@aws-amplify/ui-react';
import {signOut} from 'aws-amplify/auth';

export const useCustomSignOut = () => {
    const { signOut: amplifySignOut } = useAuthenticator();

    return useCallback(async () => {
        try {
            console.log('Custom Sign out');

            // リダイレクトURIを指定してサインアウト
            const redirectUri = process.env.REACT_APP_COGNITO_OAUTH_REDIRECT_SIGN_OUT || window.location.origin;

            // Amplifyの標準サインアウト処理（クッキーも自動的に削除される）
            await signOut({
                global: true,
                oauth: {
                    redirectUrl: redirectUri
                }
            });

            amplifySignOut();
            return {success: true};
        } catch (error) {
            console.error('Error during sign out:', error);
            // エラーを再スローせず、エラー情報を含むオブジェクトを返す
            return {
                success: false,
                error
            };
        }
    }, [amplifySignOut]);
};